import _ from "lodash";

export default function handleText(text: string | undefined) {
    return text ? text.replace(/\S+/g, _.capitalize) : ''
}